import React, { useState } from 'react';
import { BarChart3 } from 'lucide-react';
import EstimationTab from '../components/market/EstimationTab';
import DemandTab from '../components/market/DemandTab';
import ProfitabilityTab from '../components/market/ProfitabilityTab';

const TABS = [
  { id: 'estimation', label: 'Estimation' },
  { id: 'demand', label: 'Demande' },
  { id: 'profitability', label: 'Rentabilite' },
];

const Market = () => {
  const [activeTab, setActiveTab] = useState('estimation');

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-primary flex items-center gap-2">
          <BarChart3 className="h-6 w-6 text-carmin" />
          Marche
        </h1>
        <p className="text-sm text-muted mt-1">Intelligence marche et estimation de prix</p>
      </div>

      {/* Tab bar */}
      <div className="flex gap-1 bg-dark-card border border-dark-border rounded-lg p-1">
        {TABS.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex-1 h-9 rounded-md text-sm font-medium transition-colors ${
              activeTab === tab.id
                ? 'bg-carmin text-white'
                : 'text-muted hover:text-primary'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {activeTab === 'estimation' && <EstimationTab />}
      {activeTab === 'demand' && <DemandTab />}
      {activeTab === 'profitability' && <ProfitabilityTab />}
    </div>
  );
};

export default Market;
